// apps/dashboard/src/lib/cn.ts
// Tailwind class merge utility — used by every UI component.
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
